import { render, staticRenderFns } from "./myBooking.vue?vue&type=template&id=6877b1f4&"
import script from "./myBooking.vue?vue&type=script&lang=js&"
export * from "./myBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports